import Query from '../utils/Query';
import SessionStructure from "../models/SessionStructure";

const defaultFields = '*,strategy.*,component.*,dataset.*,dataset.columns.*';

export default class SessionService {

	static generate(params) {
		return Query.post('/items/session_structure', params, {
			fields: defaultFields
		}, false)
			.then(response => new SessionStructure(response.data));
	}

	static get(hash) {
		return Query.get('/items/session_structure', {
			single: 1,
			fields: defaultFields,
			filter: {
				hash,
			}
		}).then(response => new SessionStructure(response.data));
	}

	static getBySessionId(id) {
		return Query.get('/items/session', {
			single: 1,
			fields: 'session_structure.*',
			filter: {
				id,
			}
		}).then(response => new SessionStructure(response.data.session_structure));
	}
}
